module.exports = __webpack_public_path__ + "img/20220329_154435.1bed80a9.jpg";